import { useCookies } from 'react-cookie';
import { Trans } from 'react-i18next';

import styled from '@emotion/styled';
import { getServiceName } from '@repo/utils';
import { t } from 'i18next';

import { useModalFlag, useModalStackStore } from 'store/modalStackStore';

import { getExpiredDate } from 'pages/dashboard/utils/getExpiredDate';

const RevenuePeriodChangeNoticeModal = () => {
  const expires = getExpiredDate(9999);
  const [cookies, setCookie] = useCookies();
  const { closeModal } = useModalStackStore();
  const modalFlag = useModalFlag();

  const handleCloseModal = () => {
    modalFlag.setFlag(true);
    closeModal();
  };

  const handleCloseForever = async () => {
    if (cookies.USER_SET_REWARD_NOTICE_EXPIRES) return;
    setCookie(`USER_SET_REWARD_NOTICE_EXPIRES`, 'until_forever', { expires });
    handleCloseModal();
  };

  return (
    <SNoticeWrapper>
      <SContentWrapper>
        <p className="section-title">{t('chat.rewards_total_revenue_time_update_alert_title')}</p>
        <p className="section-text">
          <Trans i18nKey="chat.rewards_total_revenue_time_update_alert_description" />
        </p>
      </SContentWrapper>
      <SButtonSection>
        <SCancelButton onClick={handleCloseForever}>
          {t('chat.rewards_total_revenue_time_update_alert_button1')}
        </SCancelButton>
        <SAllowButton onClick={handleCloseModal} $isTingle={getServiceName() === 'tingle'}>
          {t('chat.rewards_total_revenue_time_update_alert_button2')}
        </SAllowButton>
      </SButtonSection>
    </SNoticeWrapper>
  );
};

export default RevenuePeriodChangeNoticeModal;

const SNoticeWrapper = styled.div`
  max-width: 320px;
  display: flex;
  padding: 20px 0 30px 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
`;

const SContentWrapper = styled.div`
  display: flex;
  padding: 16px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  .section-title {
    color: ${({ theme }) => theme.palette.common.black};
    text-align: center;

    /* Head5/SB */
    font-family: Pretendard;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px; /* 140% */
  }
  .section-text {
    color: ${({ theme }) => theme.color.text.TXT_2};
    text-align: center;

    white-space: break-spaces;
    word-break: break-all;

    /* Body2/R */
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 146.667% */
  }
`;

const SButtonSection = styled.div`
  gap: 10px;
  flex: 1 0 0;
  display: flex;
  align-items: flex-start;
`;

const Button = styled.button`
  width: 130px;
  padding: 12px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  ${({ theme }) => theme.font.body1_r};
`;

const SCancelButton = styled(Button)`
  background-color: transparent;
  color: ${({ theme }) => theme.color.text.TXT_1};
  border: 1px solid ${({ theme }) => theme.color.buttons.disable};
`;

// 팅글 리워드 CTA: yellow/black (임시, 디자인 제안 Figma 1072:58012). 버블챗은 기존 primary/white 유지
const SAllowButton = styled(Button)<{ $isTingle?: boolean }>`
  border-radius: 8px;
  color: ${({ theme, $isTingle }) => ($isTingle ? '#000000' : theme.color.static.white)};
  background: ${({ theme, $isTingle }) => ($isTingle ? theme.color.brand.primary : theme.color.static.primary)};
`;
